import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useState } from "react";
import {
  acceptOrDeclineInvitationToJoinCompany,
  getCompanyUserInvitations,
  getJoinCompanyInvitationList,
  sendEmailInvitation,
  sendEmailInvitationSuccess,
} from "../../../../store/companyToUser/action";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
import HandleDateTime from "../../../../Components/Common/HandleDateTime";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import TableContainer from "../../../../Components/Common/TableContainer";
import NoDataContent from "../../../../Components/Common/NoDataContent";
import HandleDateTimeLeft from "../../../../Components/Common/HandleDateTimeLeft";
import CompanyToUser from "../../../../store/companyToUser/reducer";
import LoadingSpinner from "../../../../Components/Common/Spinner";
import SettingsPanel from "../../components/SettingsPanel";

export default function CompanyInvitations() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getJoinCompanyInvitationList());
  }, []);
  const [userInvitationEmail, setUserInvitationEmail] = useState("");
  const { joinCompanyInvitationList, joinCompanyInvitationListLoading } =
    useSelector((state) => ({
      joinCompanyInvitationList:
        state.CompanyToUser.joinCompanyInvitationList?.userinvitation_list,
      joinCompanyInvitationListLoading:
        state.CompanyToUser.joinCompanyInvitationListLoading,
    }));

  const [searchResults, setSearchResults] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "InvitedByUser_DisplayName",
    "Id",
    "Email",
    "InvitedByUser_UserFullName",
    "InvitedByUser_Email",
  ]);

  const columns = useMemo(
    () => [
      {
        // job id with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
        filterable: false,
        Cell: (loyalty) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                <span className={"like-href"}> #{loyalty.row.original.Id}</span>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Invited By",
        accessor: "Company_BusinessName",
        filterable: true,
        Cell: (loyalty) => (
          <>
            <div>{loyalty.row.original?.Company_BusinessName}</div>
            {loyalty.row.original?.InvitedByUser_UserFullName && (
              <div> {loyalty.row.original?.InvitedByUser_UserFullName}</div>
            )}
            {loyalty.row.original?.InvitedByUser_Email && (
              <div> {loyalty.row.original?.InvitedByUser_Email}</div>
            )}
          </>
        ),
      },
      {
        Header: "Invitation Expiry Date",
        accessor: "InvitationExpiryDateTime",
        Cell: (loyalty) => {
          return (
            <>
              {loyalty.row.original?.InvitationExpiryDateTime ? (
                <div>
                  {HandleDateTimeLeft(
                    loyalty.row.original?.InvitationExpiryDateTime
                  )}
                </div>
              ) : (
                <div>Not Set</div>
              )}
            </>
          );
        },
        filterable: true,
      },
      {
        Header: "Invitation Sent Date",
        accessor: "CreatedDateTime",
        Cell: (loyalty) => {
          return (
            <>
              {loyalty.row.original?.CreatedDateTime ? (
                <div>
                  {HandleDateTime(loyalty.row.original?.CreatedDateTime)}
                </div>
              ) : (
                <div>Not Set</div>
              )}
            </>
          );
        },
        filterable: true,
      },

      {
        Header: () => <div className={"text-center"}>Action</div>,
        accessor: "action",
        Cell: (cellProps) => {
          return (
            <div className={"d-flex justify-content-center"}>
              <div className={"me-2"}>
                <button
                  className={"btn btn-primary"}
                  onClick={() => {
                    handleAcceptOrDeclineDecision(
                      "accepted",
                      cellProps.row.original?.Id
                    );
                  }}
                >
                  Accept
                </button>
              </div>
              <div>
                <button
                  className={"btn btn-danger"}
                  onClick={() => {
                    handleAcceptOrDeclineDecision(
                      "rejected",
                      cellProps.row.original?.Id
                    );
                  }}
                >
                  Decline
                </button>
              </div>
            </div>
            //
          );
        },
      },
    ],
    []
  );
  const [isTypeTab, setIsTypeTab] = useState("all");

  useEffect(() => {
    let filteredData = joinCompanyInvitationList;
    const timer = setTimeout(() => {
      // check if filter is empty or not
      if (isTypeTab === "all") {
        filteredData = filteredData?.filter((item) => item);
      }
      if (isTypeTab === "pending") {
        filteredData = filteredData?.filter(
          (item) => item?.UserInvitationDecisionStatus_Id === null
        );
      }
      if (isTypeTab === "declined") {
        filteredData = filteredData?.filter(
          (item) => item?.UserInvitationDecisionStatus_Id === 2
        );
      }
      filteredData = filteredData?.filter((item) => {
        return allowedSearchFilters?.some((key) => {
          return (
            item[key] &&
            item[key]
              .toString()
              .toLowerCase()
              .includes(searchQuery?.toLowerCase())
          );
        });
      });

      setSearchResults(filteredData);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery, isTypeTab, joinCompanyInvitationList]);

  const handleAcceptOrDeclineDecision = (Decision, Id) => {
    const sumUpDecision = {
      Id,
      Decision,
    };
    dispatch(acceptOrDeclineInvitationToJoinCompany([sumUpDecision]));
  };

  const { acceptOrDeclineInvitationToJoinCompanyAPI } = useSelector(
    (state) => ({
      acceptOrDeclineInvitationToJoinCompanyAPI:
        state.CompanyToUser.acceptOrDeclineInvitationToJoinCompany,
    })
  );

  useEffect(() => {
    if (isEmpty(acceptOrDeclineInvitationToJoinCompanyAPI)) return;
    if (acceptOrDeclineInvitationToJoinCompanyAPI.status === 200) {
      dispatch(getJoinCompanyInvitationList());
      toast.success(acceptOrDeclineInvitationToJoinCompanyAPI.message);
    } else {
      toast.error(acceptOrDeclineInvitationToJoinCompanyAPI.message);
    }
  }, [acceptOrDeclineInvitationToJoinCompanyAPI]);

  return (
    <SettingsPanel
      title="My Invitations"
      description="Invitations for you to join other companies."
      tabs={[
        { value: "pending", label: "Pending" },
        { value: "declined", label: "Declined" },
        { value: "all", label: "All" },
      ]}
      value={isTypeTab}
      onChange={setIsTypeTab}
    >
      <div>
        <Row>
          <Col lg={12}>
            <Card id="bankList">
              <CardHeader className="border-0">
                <Row className="g-4 align-items-center">
                  <Col sm={3}>
                    <div className="search-box">
                      <Input
                        // create search with jobs List Data
                        type="search"
                        className="form-control search"
                        placeholder="Search for..."
                        onChange={(e) => {
                          setSearchQuery(e.target.value);
                        }}
                        value={searchQuery}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="pt-0">
                {joinCompanyInvitationListLoading ? (
                  <LoadingSpinner />
                ) : (
                  <div>
                    {!isEmpty(searchResults) ? (
                      <TableContainer
                        columns={columns}
                        data={searchResults || []}
                        isGlobalFilter={false}
                        isAddUserList={false}
                        customPageSize={10}
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-0"
                        tableClass="align-middle table-nowrap"
                        theadClass="text-muted"
                        // handleLeadClick={handleLeadClicks}
                        isLeadsFilter={false}
                      />
                    ) : (
                      <>
                        <div>
                          <NoDataContent
                            titleText={`No Results for: ${searchQuery}`}
                            paragraphText={`Get started by sending Invitation to user`}
                            useButton={false}
                          />
                        </div>
                      </>
                    )}
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </SettingsPanel>
  );
}
